import { createUseStyles } from 'react-jss';

export default createUseStyles({
  wrapper: {
    marginBottom: '32px',
  },

  container: {
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },

  shortContainer: {
    width: '120%',
    marginBottom: '32px',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },

  inputContainer: {
    marginBottom: '0px',
    display: 'flex',
    alignItems: 'center',
    height: '50px',
  },

  codeContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  textInputContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },

  button: {
    marginLeft: '12px',
  },

  submitVideoBtn: {
    marginTop: '32px',
    '@media(max-width: 900px)': {
      marginTop: '10px',
      width: '100%',
    }
  },

  videoLinkTitle: {
    color: '#AABAA5',
    fontSize: '12px',
    marginBottom: '20px',
    marginLeft: '16px',
  },

  videoLinkInput: {
    width: '100%'
  },

  uploadingIconWrapper: {
    fontSize: '36px',
    marginLeft: '12px',
    '@media(max-width: 900px)': {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '12px',
    },
  },

  uploadingText: {
    fontSize: '13px',
    fontStyle: 'italic',
    opacity: 0.7,
    verticalAlign: 'middle',
  },

  hiddenInput: {
    display: 'none',
  },

  videoStatusContainer: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginBottom: 0,
    },
  },

  circularProgressContainer: {
    marginLeft: '20px',
    marginBottom: '5px',
  },
});
